import { Controller } from "stimulus";


export default class extends Controller {
    static targets = ["filters", "filterButton"];

    connect() {
        this.getFilterOnLoad();
    }

    open() {
        this.filtersTarget.classList.add("is-open");
        //this.mainController.bodyNoScroll();
    }

    close() {
        this.filtersTarget.classList.remove("is-open");
        //this.mainController.bodyScroll();
    }

    removeActiveFilter() {
        const $active = document.querySelector('.beer__layer-sections').querySelector('.is-active');
        if ($active) $active.classList.remove("icon-close", "is-active");
    }

    addFilter($clicked) {
        $clicked.classList.add('is-active', 'icon-close');
        this.createFilter($clicked.innerHTML);
    }

    createFilter(clicked) {
        const $filter = document.querySelector(".beer__filter-filtered");
        if ($filter) {
            $filter.querySelector('button').innerHTML = clicked;
        } else {
            const filterHtml = "<div class=\"beer__filter-filtered\"><button class=\"icon-close is-active\" data-action=\"filter#removeFilterWithButton\">" + clicked + "</button></div>";
            this.filterButtonTarget.insertAdjacentHTML("afterend", filterHtml);
        }
    }

    removeFilter() {
        const $filter = document.querySelector(".beer__filter-filtered");
        $filter.parentNode.removeChild($filter);
    }

    filter(e) {
        e.preventDefault();

        var filterButton = e.currentTarget;
        var filterType = filterButton.dataset.filterType;
        var filterValue = filterButton.dataset.filterValue;
        var filter = "data-" + filterType;
        //URL
        if (window.location.href.indexOf('#filter=') > -1) {
            //window.location.href = window.location.href.split('#filter=')[0] + "#filter=" + filterValue;
            var newFilterUrl = window.location.href.split('#filter=')[0] + "#filter=" + filterType + "&value=" + filterValue;
            history.pushState({ turbolinks: true, url: newFilterUrl }, '', newFilterUrl)
        } else {
            //window.location.href = window.location.href + "#filter=" + filterValue;
            var filterUrl = window.location.href + "#filter=" + filterType + "&value=" + filterValue;
            history.pushState({ turbolinks: true, url: filterUrl }, '', filterUrl)
        }


        //sezioni birre
        var draftSection = document.querySelector('.beer__section.--draft');
        var bottleSection = document.querySelector('.beer__section.--bottle');
        var canSection = document.querySelector('.beer__section.--can');

        //spina
        var darftBeerList = document.querySelectorAll('.beer__section.--draft .beer__item');
        var darftBeerListCount = darftBeerList.length;
        //bottiglia
        var bottleBeerList = document.querySelectorAll('.beer__section.--bottle .beer__item');
        var bottleBeerListCount = bottleBeerList.length;
        //lattina
        var canBeerList = document.querySelectorAll('.beer__section.--can .beer__item');
        var canBeerListCount = canBeerList.length;

        if (filterButton.classList.contains('is-active')) {
            //se il filtro che clicco è quello attivo ---> resetto filtri

            //aggiorno filtri
            this.removeActiveFilter();
            this.removeFilter();
            //resetto visibilità sezioni birre
            this.resetBeerSectionVisibility();
            //resetto visibilità item birre
            this.resetBeerListItemsVisibility();
            //resetto numero birre spina
            if (draftSection) {
                document.querySelector('.beer__section.--draft .beer__section-header h3 strong').innerText = darftBeerListCount;
            }
            //resetto numero birre bottiglia
            if (bottleSection) {
                document.querySelector('.beer__section.--bottle .beer__section-header h3 strong').innerText = bottleBeerListCount;
            }
            //resetto numero birre lattina
            if (canSection) {
                document.querySelector('.beer__section.--can .beer__section-header h3 strong').innerText = canBeerListCount;
            }

            //resetto url
            this.resetFilterUrl();
        }
        else
        {
            //se il filtro che clicco non è il filtro attivo ---> filtro le birre
            
            //aggiorno filtri
            this.removeActiveFilter();
            this.addFilter(e.currentTarget);
            //aggiorno lista birre spina
            var updateDraftCount = 0;
            darftBeerList.forEach((item) => {
                var itemData = item.getAttribute(filter);
                if (itemData == filterValue) {
                    item.style.display = '';
                    updateDraftCount += 1;
                } else {
                    item.style.display = 'none';
                }
            });
            //aggiorno numero birre spina
            if (draftSection) {
                document.querySelector('.beer__section.--draft .beer__section-header h3 strong').innerText = updateDraftCount;
                if (updateDraftCount == 0) {
                    document.querySelector('.beer__section.--draft').style.display = 'none';
                } else {
                    document.querySelector('.beer__section.--draft').style.display = '';
                }
            }
            
            
            //aggiorno lista birre bottiglia
            var updateBottleCount = 0;
            bottleBeerList.forEach((item) => {
                var itemData = item.getAttribute(filter);
                if (itemData == filterValue) {
                    item.style.display = '';
                    updateBottleCount += 1;
                } else {
                    item.style.display = 'none';
                }
            });
            //aggiorno numero birre bottiglia
            if (bottleSection) {
                document.querySelector('.beer__section.--bottle .beer__section-header h3 strong').innerText = updateBottleCount;
                if (updateBottleCount == 0) {
                    document.querySelector('.beer__section.--bottle').style.display = 'none';
                } else {
                    document.querySelector('.beer__section.--bottle').style.display = '';
                }
            }
            
            
            //aggiorno lista birre lattina
            var updateCanCount = 0;
            canBeerList.forEach((item) => {
                var itemData = item.getAttribute(filter);
                if (itemData == filterValue) {
                    item.style.display = '';
                    updateCanCount += 1;
                } else {
                    item.style.display = 'none';
                }
            });
            //aggiorno numero birre lattina
            if (canSection) {
                document.querySelector('.beer__section.--can .beer__section-header h3 strong').innerText = updateCanCount;
                if (updateCanCount == 0) {
                    document.querySelector('.beer__section.--can').style.display = 'none';
                } else {
                    document.querySelector('.beer__section.--can').style.display = '';
                }
            } 
        }
        
        //chiudo layer filtri
        this.close();
    }

    removeFilterWithButton(e) {
        e.preventDefault();
        //rimuovo filtro
        this.removeActiveFilter();
        this.removeFilter();
        //resetto display sezioni birre
        this.resetBeerSectionVisibility();
        //resetto display item birre
        this.resetBeerListItemsVisibility();
        //resetto count numero birre
        this.resetBeerListItemsCount();
        //resetto url
        this.resetFilterUrl();
    }

    resetBeerSectionVisibility() {
        //sezioni birre
        var draftSection = document.querySelector('.beer__section.--draft');
        var bottleSection = document.querySelector('.beer__section.--bottle');
        var canSection = document.querySelector('.beer__section.--can');
        if (draftSection) {
            document.querySelector('.beer__section.--draft').style.display = '';
        }
        if (bottleSection) {
            document.querySelector('.beer__section.--bottle').style.display = '';
        }
        if (canSection) {
            document.querySelector('.beer__section.--can').style.display = '';
        }
    }

    resetBeerListItemsVisibility() {
        var beerItems = document.querySelectorAll('.beer__item');
        beerItems.forEach((item) => {
            item.style.display = '';
        });
    }

    resetBeerListItemsCount() {
        //sezioni birre
        var draftSection = document.querySelector('.beer__section.--draft');
        var bottleSection = document.querySelector('.beer__section.--bottle');
        var canSection = document.querySelector('.beer__section.--can');
        //spina
        var darftBeerList = document.querySelectorAll('.beer__section.--draft .beer__item');
        var darftBeerListCount = darftBeerList.length;
        //bottiglia
        var bottleBeerList = document.querySelectorAll('.beer__section.--bottle .beer__item');
        var bottleBeerListCount = bottleBeerList.length;
        //lattina
        var canBeerList = document.querySelectorAll('.beer__section.--can .beer__item');
        var canBeerListCount = canBeerList.length;
        //resetto numero birre spina
        if (draftSection) {
            document.querySelector('.beer__section.--draft .beer__section-header h3 strong').innerText = darftBeerListCount;
        }
        //resetto numero birre bottiglia
        if (bottleSection) {
            document.querySelector('.beer__section.--bottle .beer__section-header h3 strong').innerText = bottleBeerListCount;
        }
        //resetto numero birre lattina
        if (canSection) {
            document.querySelector('.beer__section.--can .beer__section-header h3 strong').innerText = canBeerListCount;
        }
    }

    resetFilterUrl() {
        if (window.location.href.indexOf('#filter=') > -1) {
            var resetUrl = window.location.href.split('#filter=')[0];
            history.pushState({ turbolinks: true, url: resetUrl }, '', resetUrl)
        }
    }

    getFilterOnLoad() {
        if (window.location.href.indexOf('#filter=') > -1) {
            var urlFilterType = window.location.href.split('#filter=')[1].split('&value=')[0];
            var urlFilterValue = window.location.href.split('&value=')[1];
            var filter = "data-" + urlFilterType;

            //filtrare birre
            var filterLayerBtn = document.querySelector('.beer__filter-list button[data-filter-type=' + urlFilterType + '][data-filter-value=' + urlFilterValue + ']');
            this.createFilter(filterLayerBtn.innerHTML);
            filterLayerBtn.classList.add('is-active', 'icon-close');
            //this.removeActiveFilter();
            //sezioni birre
            var draftSection = document.querySelector('.beer__section.--draft');
            var bottleSection = document.querySelector('.beer__section.--bottle');
            var canSection = document.querySelector('.beer__section.--can');

            //spina
            var darftBeerList = document.querySelectorAll('.beer__section.--draft .beer__item');
            //bottiglia
            var bottleBeerList = document.querySelectorAll('.beer__section.--bottle .beer__item');
            //lattina
            var canBeerList = document.querySelectorAll('.beer__section.--can .beer__item');

            //aggiorno lista birre spina
            var updateDraftCount = 0;
            darftBeerList.forEach((item) => {
                var itemData = item.getAttribute(filter);
                if (itemData == urlFilterValue) {
                    item.style.display = '';
                    updateDraftCount += 1;
                } else {
                    item.style.display = 'none';
                }
            });
            //aggiorno numero birre spina
            if (draftSection) {
                document.querySelector('.beer__section.--draft .beer__section-header h3 strong').innerText = updateDraftCount;
                if (updateDraftCount == 0) {
                    document.querySelector('.beer__section.--draft').style.display = 'none';
                } else {
                    document.querySelector('.beer__section.--draft').style.display = '';
                }
            }

            //aggiorno lista birre bottiglia
            var updateBottleCount = 0;
            bottleBeerList.forEach((item) => {
                var itemData = item.getAttribute(filter);
                if (itemData == urlFilterValue) {
                    item.style.display = '';
                    updateBottleCount += 1;
                } else {
                    item.style.display = 'none';
                }
            });
            //aggiorno numero birre bottiglia
            if (bottleSection) {
                document.querySelector('.beer__section.--bottle .beer__section-header h3 strong').innerText = updateBottleCount;
                if (updateBottleCount == 0) {
                    document.querySelector('.beer__section.--bottle').style.display = 'none';
                } else {
                    document.querySelector('.beer__section.--bottle').style.display = '';
                }
            }

            //aggiorno lista birre lattina
            var updateCanCount = 0;
            canBeerList.forEach((item) => {
                var itemData = item.getAttribute(filter);
                if (itemData == urlFilterValue) {
                    item.style.display = '';
                    updateCanCount += 1;
                } else {
                    item.style.display = 'none';
                }
            });
            //aggiorno numero birre lattina
            if (canSection) {
                document.querySelector('.beer__section.--can .beer__section-header h3 strong').innerText = updateCanCount;
                if (updateCanCount == 0) {
                    document.querySelector('.beer__section.--can').style.display = 'none';
                } else {
                    document.querySelector('.beer__section.--can').style.display = '';
                }
            }
        }
        else {
            //resetto in caso di back con tasto browser
            this.removeActiveFilter();
            if (document.querySelector(".beer__filter-filtered")) {
                this.removeFilter();
            }
            //resetto display sezioni birre
            this.resetBeerSectionVisibility();
            //resetto display item birre
            this.resetBeerListItemsVisibility();
            //resetto count numero birre
            this.resetBeerListItemsCount();
        }
    }

    get mainController() {
        return this.application.getControllerForElementAndIdentifier(document.querySelector('body'), "main");
    }
}

